import React, { useEffect, useRef, useState } from "react";
import styles from './SLogoNew.module.css';

import { ReactComponent as SLogoSVG } from '../../imgs/SLogoAlt.svg';
import { SemiWithBitePair } from "../home/SemiBites";

export default function SLogoNew({scrollState,height,width,viewportHeight,mask,logoScale,background,fill,maskId}){

    const bgObject = {
        '1': 'newBackground',
        '2': 'newBackground2',
    }

    const [outerDivDims,setOuterDivDims] = useState({
        height: 0,
        width: 0,
    });

    const outerDivRef = useRef();

    useEffect(() => {
        if(outerDivRef){
            if(outerDivRef.current){
                setOuterDivDims({
                    height: outerDivRef.current.getBoundingClientRect().bottom-outerDivRef.current.getBoundingClientRect().top,
                    width: outerDivRef.current.getBoundingClientRect().right-outerDivRef.current.getBoundingClientRect().left,
                })
            }
        }
    },[outerDivRef,window.innerHeight,window.innerWidth]);

    useEffect(() => {
        console.log(outerDivDims);
    },[outerDivDims]);


    if(mask){
        return (
            <div style={
                {
                    position: 'relative',
                    height: '100%',
                }
            }>
                <div ref={outerDivRef} style={
                    {
                        display: 'flex',
                        justifyContent: 'center',
                        alignContent: 'center',
                        alignItems: 'center',
                        height: height,
                        width: width,
                        position: 'relative',
                    }}>
                    <div className={styles[bgObject[background]]} style={
                        {
                            display: 'flex',
                            justifyContent: 'center',
                            height: outerDivDims.height > outerDivDims.width? outerDivDims.width : outerDivDims.height,
                            maskImage: `url(#${maskId})`
                        }}>
                        <SemiWithBitePair outerDiameter={59.82} innerDiameter={36} scrollState={scrollState} fill="#fff" height={outerDivDims.height > outerDivDims.width? outerDivDims.width : outerDivDims.height} mask={mask} logoScale={logoScale} maskId={maskId}/>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div style={
                {
                    position: 'relative',
                }
            }>
                <div ref={outerDivRef} style={
                    {
                        display: 'flex',
                        justifyContent: 'center',
                        height: height,
                        width: width,
                        position: 'relative',
                    }}>
                        
                    <div className={styles[bgObject[background]]} style={
                        {
                            display: 'flex',
                            justifyContent: 'center',
                            height: height,
                            width: width,
                            maskImage: 'unset'
                        }}>
                            
                        <SemiWithBitePair
                        outerDiameter={59.82}
                        innerDiameter={36}
                        scrollState={scrollState}
                        fill={fill}
                        height={outerDivDims.height > outerDivDims.width? outerDivDims.width : outerDivDims.height}
                        mask={false}
                        logoScale={logoScale}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

{/* <SemiWithBitePair
    outerDiameter={59.82}
    innerDiameter={36}
    rotation={90}
    x={100}
    y={100}
    scrollState={scrollState}
    fill="rgb(212, 227, 245)"
    /> */}